import { render, staticRenderFns } from "./ArticleTitlePage.vue?vue&type=template&id=62926cc0&scoped=true"
import script from "./ArticleTitlePage.vue?vue&type=script&lang=js"
export * from "./ArticleTitlePage.vue?vue&type=script&lang=js"
import style0 from "./ArticleTitlePage.vue?vue&type=style&index=0&id=62926cc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62926cc0",
  null
  
)

export default component.exports